/* eslint-disable no-console, import/prefer-default-export */
import { scrollToError } from './configuration-utils';

// For some props, we'll need to check whether step is
// "avaialble" (hidden) to determine if empty string is
// valid.
const validProps = {
  cordSide: false,
  fabric: false,
  fabricCode: false,
  frameColor: false,
  model: false,
  mount: false,
  projection: false,
  size: false,
  valanceStyle: false,
};

const costcoValidProps = {
  cordSide: false,
  fabric: false,
  fabricCode: false,
  frameColor: false,
  model: false,
  mount: false,
  projection: false,
  size: false,
  valanceStyle: false,
};

const getInvalidProps = (state) => {
  const arr = [];
  const { isCostco } = state;
  const props = isCostco ? costcoValidProps : validProps;
  Object.keys(props).forEach((key) => {
    if (state[key] === '') {
      props[key] = false;
      arr.push(key);
    } else {
      props[key] = true;
    }
  });
  return arr;
};

const isValid = (state) => {
  let v = true;
  const { isCostco } = state;
  const props = isCostco ? costcoValidProps : validProps;
  Object.keys(props).forEach((key) => {
    if (!props[key]) {
      v = false;
    }
  });
  return v;
};

const validate = (state) => {
  const stepErrors = document.querySelectorAll('[data-step-error]');
  const invalidProps = getInvalidProps(state);
  const valid = isValid(state);
  console.log(invalidProps);
  [].map.call(stepErrors, (item) => {
    const step = item.getAttribute('data-step-error');
    if (invalidProps.indexOf(step) !== -1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
  if (!valid) {
    const visibleErrors = document.querySelectorAll('[data-step-error]:not(.hidden)');
    if (visibleErrors.length > 0) {
      const step = visibleErrors[0].getAttribute('data-step-error');
      scrollToError(step);
    }
  }
  return valid;
};

export {
  validate,
};
/* eslint-enable no-console, import/prefer-default-export */
